import React, { FC, ReactNode, SVGProps } from 'react'

import { Tooltip } from '../../Tooltip'
import * as S from './AIElements.styles'

interface IconTooltipProps {
  content: ReactNode
  icon: FC<SVGProps<SVGSVGElement>>
}

export const IconTooltip: FC<IconTooltipProps> = ({ content, icon }) => {
  const Icon = icon

  return (
    <Tooltip placement="top" content={content}>
      <S.IconWrapper>
        <Icon />
      </S.IconWrapper>
    </Tooltip>
  )
}
